import {inject, Injectable} from '@angular/core';
import {PortalPublicClientService} from './portal-public-client.service';

@Injectable({
    providedIn: 'root'
})
export class BrandService {
    private readonly portal = inject(PortalPublicClientService);

    async getBrandByName(name: string): Promise<Record<string, unknown> | null> {
        return (await this.portal.brand(name))?.brand ?? null;
    }

    getBrandByDomain(domain: string): Promise<string | null> {
        return this.portal.brandNameOfDomain(domain);
    }
}
